import React from "react";
import { Container } from "react-bootstrap";
import { useSelector } from "react-redux";
import { dashBoard } from "content/dashbaord";

const Home = () => {
  const { user } = useSelector((state) => state.auth);

  return (
    <Container fluid className="px-5 pt-4 pb-4 mb-3">
      {dashBoard[user?.role]}
    </Container>
  );
};

export default Home;